import { Box, Button, ButtonProps, CircularProgress } from '@mui/material';
import { forwardRef } from 'react';

export interface LoadingButtonProps extends ButtonProps {
  loadingText?: string;
  loading?: boolean;
}

const LoadingButton: React.FC<LoadingButtonProps> = forwardRef((props, ref) => {
  const { children, loadingText = children, loading, disabled, ...muiButtonProps } = props;

  return (
    <Button ref={ref} disabled={loading || disabled} {...muiButtonProps}>
      {loading ? (
        <Box display="flex" alignItems="center">
          <CircularProgress color="inherit" size="1rem" sx={{ mr: 1 }} />
          {loadingText}
        </Box>
      ) : (
        children
      )}
    </Button>
  );
});

export default LoadingButton;
